<template>
  <div class="pick">
    <!-- <a-range-picker :disabledDate="disabledDate" class="picker" @change="onDateChange" /> -->
    <a-range-picker style="width:100%" class="picker" :disabledDate="disabledDate" :ranges="{
      [$t('global.today')]: [moment().startOf('day'), moment()],
      [$t('global.lastThreeDays')]: [moment().subtract('days', 2).startOf('day'), moment()],
      [$t('global.lastSevenDays')]: [moment().subtract('days', 6).startOf('day'), moment()],
      [$t('global.lastThirtyDays')]: [moment().subtract('days', 29).startOf('day'), moment()],
      [$t('global.thisWeek')]: [moment().startOf('week'), moment()],
      [$t('global.thisMounth')]: [moment().startOf('month'), moment()]
    }" showTime format="YYYY/MM/DD HH:mm:ss" @change="onDateChange" v-model="dates" />
    <div class="slide">
      <a-slider :min="slideMin" :max="moment().unix()" :tooltipVisible="false" range v-model="slideDates"
        :tipFormatter="tipFormatter" @change="slideChange" />
    </div>
    <div>
      <a-radio-group v-model="trackType" @change="onTrackTypeChange">
        <!-- <a-radio value="1">{{$t('global.allTrack')}}</a-radio> -->
        <a-radio value="3">{{ $t('global.outTrack') }}</a-radio>
        <a-radio value="2">{{ $t('global.inTrack') }}</a-radio>
      </a-radio-group>
    </div>

    <div class="filter-row">
      <span>{{ $t('global.filterDistance') }}</span>
      <a-input v-model="filterDistance" size="small"  style="width: 120px;margin: 10px 0;" addonAfter="米"
    type="number"
    :min="0"  
    :step="0.1"
      />
    </div>

    <div class="btns">
      <a-button-group>
        <template v-for="(date, index) in defaultDates">
          <a-button :type="activeIndex === index ? 'primary' : 'default'" @click="doDatesSearch(date.value, index)"
            :key="index">{{ date.name }}</a-button>
        </template>
      </a-button-group>
      <a-button class="btn" type="primary" @click="getTrackPoints" :disabled="isSearchBtnDisabled">{{
        $t('global.trackSearch')
      }}</a-button>
      <!-- <a-button class="btn">实时追踪</a-button> -->

    </div>
  </div>
</template>
<script>
import config from '../../config/'
import moment from 'moment'
export default {
  props: {
    personInfo: {
      required: true
    }
  },
  data() {
    return {
      dates: [moment().subtract('days', 0).startOf('day'), moment()],
      activeIndex: 0,
      // defaultDates: [
      //   {name: '今天', value: 1},
      //   {name: '近三天', value: 3},
      //   {name: '近七天', value: 7},
      //   {name: '近三十天', value: 30},
      // ],
      selectedDate: '',
      startTime: moment().subtract('days', 0).startOf('day').unix(),
      endTime: moment().unix(),
      slideDates: [moment().subtract('days', 0).startOf('day').unix(), moment().unix()],
      slideMin: moment().subtract('days', 6).startOf('day').unix(),
      trackType: '3',
      filterDistance: 10,
    }
  },
  computed: {
    // 查询轨迹的按钮是否可用
    isSearchBtnDisabled() {
      // 如果选择了时间区间就可以使用
      if (this.dates.length === 2) {
        return false
      } else {
        return true
      }
    },
    // slideDates () {
    //   return this.dates.map((m) => {
    //     return m.unix()
    //   })
    // },
    defaultDates() {
      return [
        { name: this.$t('global.today'), value: 1 },
        { name: this.$t('global.lastThreeDays'), value: 3 },
        { name: this.$t('global.lastSevenDays'), value: 7 },
        { name: this.$t('global.lastThirtyDays'), value: 30 },
      ]
    },
  },
  mounted() {
    // this.getTrackPoints()
  },
  methods: {
    moment,
    tipFormatter(num) {
      return moment(num * 1000).format('YYYY-MM-DD HH:mm')
    },
    slideChange(ev) {
      // console.log(ev)
      this.startTime = ev[0]
      this.endTime = ev[1]
      if (this.startTime < this.slideMin) {
        this.slideMin = this.startTime
      }
      this.dates = [moment(this.startTime * 1000), moment(this.endTime * 1000)]
      this.activeIndex = ''
    },
    // 直接选择时间查询
    doDatesSearch(value, index) {
      // 计算选取的时间
      if (value === 1) {
        this.dates = [moment().subtract('days', value - 1).startOf('day'), moment()]
      } else {
        this.dates = [moment().subtract('days', value - 1).startOf('day'), moment()]
      }
      this.activeIndex = index
      this.startTime = this.dates[0].unix()
      this.endTime = this.dates[1].unix()
      if (this.startTime < this.slideMin) {
        this.slideMin = this.startTime
      }
      this.slideDates = this.dates.map((m) => {
        return m.unix()
      })
      // this.selectedDate = [...this.dates]
    },
    // 不可选择的时间， 未来的时间 今天 || 今天之后
    disabledDate(date) {
      // console.log(date)
      return date && date > moment().endOf('day')
    },
    // 当选择的时间改变时触发
    onDateChange(date, dateString) {
      // console.log(date, dateString)
      // 将时间转为时间戳 到 秒
      if (date.length === 2) {
        // this.startTime = date[0]._d ? Date.parse(date[0]._d) / 1000 : ''
        this.startTime = moment(date[0]).unix()
        if (this.startTime < this.slideMin) {
          this.slideMin = this.startTime
        }
        this.endTime = moment(date[1]).unix()
        this.selectedDate = dateString
        this.slideDates = date.map((m) => {
          return m.unix()
        })
      } else {
        this.selectedDate = ''
        this.slideDates = []
      }
      this.activeIndex = ''
      // console.log(this.dates)
    },
    onTrackTypeChange(e) {
      this.trackType = e.target.value
    },
    // 异步获取轨迹点 array
    getTrackPoints() {
      //this.$emit('handleStop')
      // 此时页面加载状态
      this.$emit('isLoading', true)
      // 应该去查询数据....
      let params = {
        startTime: this.startTime,
        endTime: this.endTime,
        trackType: this.trackType,
        filterDistance: this.filterDistance,
      }
      // console.log(params)
      // console.log(this.personInfo)
      this.$http.post(config.api.get_personnal_track_points + this.personInfo.key, params).then((res) => {
        setTimeout(() => {
          if (res.code === 0) {
            // ...
            // console.log(res)
            let data = res.result
            if (data.filter && data.filter.length > 0) {
              // 3 传递事件
              data.filter.forEach((item) => {
                if (item.isAlarm) {
                  switch (item.code) {
                    case 21:
                      item.message = this.$t('alarm.SOS告警')
                      break;
                    case 12:
                      item.message = this.$t('alarm.SOS取消')
                      break;
                    case 22:
                      item.message = this.$t('alarm.表带损坏告警')
                      break;
                    case 26:
                      item.message = this.$t('alarm.异常开锁告警')
                      break;
                    case 31:
                      item.message = this.$t('alarm.围栏告警')
                      break;
                    case 1:
                      item.message = this.$t('alarm.设备低电告警')
                      break;
                    case 10002:
                      item.message = this.$t('alarm.心率异常告警')
                      break;
                    case 10006:
                      item.message = this.$t('alarm.体温异常告警')
                      break;
                    case 10007:
                      item.message = this.$t('alarm.超员告警')
                      break;
                  }
                }
              })
              this.$emit('getPoints', data)
            } else {
              this.$notification.open({
                message: this.$t('global.很抱歉没有查询到轨迹记录')
                // message: res.desc
              })
            }
          } else {
            this.$notification.open({
              // message: '很抱歉没有查询到轨迹记录'
              message: res.desc
            })
          }
          this.$emit('isLoading', false)
        }, 1000)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.pick {
  width: 100%;
  // box-shadow: 1px 1px 3px #aaa;
  border-bottom: 1px solid rgb(212, 203, 203);
  padding: 20px 10px;

  // margin-bottom: 20px;
  .slide {
    // margin-top: 40px;
    margin-top: 5px;
  }

  .picker {
    width: 100%;
  }

  .btns {
    // background: #000;
    margin-top: 10px;
    width: 100%;
    display: grid;
    // grid-template-columns: repeat(2, 1fr);
    grid-template-columns: 3fr 1fr;
    grid-column-gap: 10px;

    .btn {
      box-sizing: border-box;
      width: 100%;
    }
  }

  .filter-row {
    display: flex;
    align-items: center;
    gap: 10px; 

    span {
      white-space: nowrap;
    }
    
  }
}
</style>
